import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForumPage from "@/pages/ForumPage";
import ThreadPage from "@/pages/ThreadPage";
import NewThread from "@/pages/NewThread";
import Profile from "@/pages/Profile";
import Settings from "@/pages/Settings";
import SearchPage from "@/pages/SearchPage";
import Admin from "@/pages/Admin";
import Messages from "@/pages/Messages";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import VerifyEmail from "@/pages/VerifyEmail";
import RouteMeta from "@/components/RouteMeta";

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <RouteMeta />
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password/:token" element={<ResetPassword />} />
              <Route path="/verify-email/:token" element={<VerifyEmail />} />
              <Route path="/f/:forumId" element={<ForumPage />} />
              <Route path="/f/:forumId/new" element={<NewThread />} />
              <Route path="/t/:threadId" element={<ThreadPage />} />
              <Route path="/u/:username" element={<Profile />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/search" element={<SearchPage />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/messages" element={<Messages />} />
              <Route path="/messages/:convId" element={<Messages />} />
            </Routes>
          </Layout>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
